<script setup>

const { offer_type_associative } = useAppConfig()
const commercialStore = useCommercialStore()
const favoritesStore = useFavoritesStore()
favoritesStore.init()

const { params } = useRoute()
const { id } = params

await commercialStore.getBuildItem(id)

if ( !commercialStore.build_item ) {
    throw createError({
        statusCode: 404,
        statusMessage: 'Page Not Found'
    })
}
// console.log('id', commercialStore.build_item);

const selectViewContainer = ref('map')
const getType = t => {
    return (offer_type_associative[t] !== undefined) ? offer_type_associative[t] : 'помещения'
}

const phone = ref(false);
const email = ref(false);

commercialStore.getBuildOffers(id)
const isVisible = computed(() => {
    return (commercialStore.build_offers.items.length > 0) ? true : false
})

const formData = ref({
    name: '',
    token: '',
    email: '',
    phone: '',
    object_id: commercialStore.build_item?.id,
    object_header: commercialStore.build_item?.name,
    object_link: `https://arendabc.ru/bci/${commercialStore.build_item?.id}`,
});

const submitFormApplicationForObject = async () => {
    try {
        const RECAPTCHA_PUBLIC = '6LehhpcqAAAAAPeAFBjLDowlFKhwp9vjStWtgGlF'
        grecaptcha.ready( () => {
            grecaptcha.execute( RECAPTCHA_PUBLIC, {action: 'submit'}).then( async (token) =>  {

                formData.value.token = token

                const response = await fetch('/api/forms/object', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData.value),
                });

                const result = await response.json();
                if (result.status === 'success') {
                    // console.log('Форма успешно отправлена');
                    // console.log(result);
                    useToastify.success('Заявка отправлена', {
                        theme: 'colored',
                        autoClose: 5000,
                        position: ToastifyOption.POSITION.TOP_RIGHT,
                    });

                    ym(54350782,'reachGoal','object')
                    formData.value = {
                        name: '',
                        email: '',
                        phone: '',
                    }
                } else if( result.status === 'error' ){
                    // console.error(result.errors);
                    useToastify.error('Заявка не отправлена', {
                        theme: 'colored',
                        autoClose: 5000,
                        position: ToastifyOption.POSITION.TOP_RIGHT,
                    });
                }
            });
        });
    } catch (error) {
        // console.error('Ошибка отправки формы:', error);
        useToastify.error('Заявка не отправлена', {
            theme: 'colored',
            autoClose: 5000,
            position: ToastifyOption.POSITION.TOP_RIGHT,
        });
    }
};

useSeoMeta({
    title: commercialStore.build_item?.name,
})

</script>

<template>

    <div class="h-full bg-brand-bright">

        <section data-offer
            class="bg-[url('public/img/offer.png')] bg-no-repeat bg-cover bg-center md:py-6 max-[768px]:bg-none bg-brand-bright">
            <div class="container">

                <div class="flex justify-between flex-col md:flex-row md:items-center py-6 md:py-4">
                    <div>
                        <p class="font-semibold text-sm uppercase">
                            <span v-if="commercialStore.build_item?.type_zdania">{{
                                commercialStore.build_item?.type_zdania }} </span>
                            <span v-if="commercialStore.build_item?.type"> {{ commercialStore.build_item?.type_space
                                }}</span>
                        </p>
                        <h1 class="text-gray-100 font-bold text-xl md:text-2xl uppercase">
                            {{ commercialStore.build_item?.name }}
                        </h1>
                    </div>
                    <div class="flex gap-2 items-center pt-3 md:pt-0 justify-between">
                        <!-- <button
                            class="bg-red-500 flex items-center w-1/2 justify-center md:px-4 py-2 text-white gap-2 rounded md:w-auto">
                            <img src="/img/icons/pdf.svg" alt="" />
                            Распечатать
                        </button> -->
                        <nuxt-link :to="`/build/${commercialStore.build_item?.id}/print`"
                            class="bg-red-500 hover:bg-red-600 flex items-center w-1/2 justify-center md:px-4 py-2 text-white gap-2 rounded md:w-auto text-base">
                            <img src="/img/icons/print.svg" alt="print" />
                            Распечатать
                        </nuxt-link>
                        <button v-if="favoritesStore.is(commercialStore.build_item?.id, 'offers')"
                            @click.prevent="favoritesStore.toggle(commercialStore.build_item?.id, 'offers')"
                            class="bg-brand-blue flex items-center px-6 md:px-4 py-2 text-white gap-2 rounded w-1/2 justify-center md:w-auto">
                            <span class="cursor-pointer flex justify-center">
                                <svg width="22" height="23" viewBox="0 0 22 23" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.13317 6.7179L0.844199 7.69835L0.732811 7.72273C0.564191 7.77086 0.410472 7.86626 0.287351 7.99917C0.164231 8.13208 0.0761199 8.29774 0.032017 8.47924C-0.012086 8.66074 -0.010601 8.85158 0.0363201 9.03226C0.0832413 9.21295 0.173917 9.377 0.299089 9.50768L4.85514 14.2764L3.78069 21.0123L3.76788 21.1289C3.75756 21.3164 3.79377 21.5036 3.87281 21.6711C3.95185 21.8386 4.07088 21.9806 4.2177 22.0824C4.36453 22.1842 4.53388 22.2422 4.70841 22.2505C4.88295 22.2587 5.05639 22.217 5.21099 22.1295L10.8356 18.9497L16.4473 22.1295L16.5459 22.1783C16.7086 22.2472 16.8855 22.2683 17.0583 22.2395C17.2311 22.2107 17.3936 22.1329 17.5293 22.0143C17.6649 21.8956 17.7688 21.7402 17.8302 21.5642C17.8916 21.3881 17.9083 21.1976 17.8786 21.0123L16.8032 14.2764L21.3612 9.50662L21.4381 9.41652C21.5479 9.27106 21.6199 9.0969 21.6468 8.91177C21.6737 8.72664 21.6544 8.53717 21.591 8.36265C21.5276 8.18813 21.4223 8.03481 21.2858 7.9183C21.1493 7.8018 20.9866 7.72627 20.8141 7.69941L14.5252 6.7179L11.7139 0.591417C11.6325 0.413913 11.5066 0.26444 11.3503 0.159918C11.194 0.0553963 11.0137 0 10.8297 0C10.6456 0 10.4653 0.0553963 10.309 0.159918C10.1527 0.26444 10.0268 0.413913 9.94546 0.591417L7.13317 6.7179Z"
                                        fill="#fff" />
                                </svg>
                            </span>
                            Добавлено
                        </button>
                        <button v-if="!favoritesStore.is(commercialStore.build_item?.id, 'offers')"
                            @click.prevent="favoritesStore.toggle(commercialStore.build_item?.id, 'offers')"
                            class="bg-blue-100 flex items-center px-6 md:px-4 py-2 text-brand-primary gap-2 rounded w-1/2 justify-center md:w-auto">
                            <span class="cursor-pointer flex justify-center">
                                <svg width="22" height="23" viewBox="0 0 22 23" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.13317 6.7179L0.844199 7.69835L0.732811 7.72273C0.564191 7.77086 0.410472 7.86626 0.287351 7.99917C0.164231 8.13208 0.0761199 8.29774 0.032017 8.47924C-0.012086 8.66074 -0.010601 8.85158 0.0363201 9.03226C0.0832413 9.21295 0.173917 9.377 0.299089 9.50768L4.85514 14.2764L3.78069 21.0123L3.76788 21.1289C3.75756 21.3164 3.79377 21.5036 3.87281 21.6711C3.95185 21.8386 4.07088 21.9806 4.2177 22.0824C4.36453 22.1842 4.53388 22.2422 4.70841 22.2505C4.88295 22.2587 5.05639 22.217 5.21099 22.1295L10.8356 18.9497L16.4473 22.1295L16.5459 22.1783C16.7086 22.2472 16.8855 22.2683 17.0583 22.2395C17.2311 22.2107 17.3936 22.1329 17.5293 22.0143C17.6649 21.8956 17.7688 21.7402 17.8302 21.5642C17.8916 21.3881 17.9083 21.1976 17.8786 21.0123L16.8032 14.2764L21.3612 9.50662L21.4381 9.41652C21.5479 9.27106 21.6199 9.0969 21.6468 8.91177C21.6737 8.72664 21.6544 8.53717 21.591 8.36265C21.5276 8.18813 21.4223 8.03481 21.2858 7.9183C21.1493 7.8018 20.9866 7.72627 20.8141 7.69941L14.5252 6.7179L11.7139 0.591417C11.6325 0.413913 11.5066 0.26444 11.3503 0.159918C11.194 0.0553963 11.0137 0 10.8297 0C10.6456 0 10.4653 0.0553963 10.309 0.159918C10.1527 0.26444 10.0268 0.413913 9.94546 0.591417L7.13317 6.7179Z"
                                        fill="#00b6f4" />
                                </svg>
                            </span>
                            Добавить
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <section class="detail py-6">
            <div class="container flex md:gap-6 gap-3.5 flex-col md:flex-row">

                <div class="absolute z-10 flex items-center gap-1 mt-2 ms-28 ps-1">
                    <div v-if="commercialStore.build_item?.build_class"
                        class="flex bg-brand-dark h-[22px] md:h-[26px] p-3 items-center justify-center rounded-md">
                        <p class="text-white text-[14px] md:font-normal p-0 ">Класс {{ capitalize(
                            commercialStore.build_item?.build_class) }}</p>
                    </div>
                </div>

                <div class="flex flex-col items-center w-2/2 md:w-3/5">

                    <OfferGalery v-model="commercialStore.build_item" />

                    <div class="py-6 px-6 bg-white border mt-3 rounded-lg text-brand-grey w-full mt-4">

                        <LayoutsMetro v-model="commercialStore.build_item.metros"
                            v-if="commercialStore.build_item.metros" class="py-2" />

                        <OfferDescription v-model="commercialStore.build_item" />

                        <div class="items-center justify-between pt-5 hidden md:flex">
                            <p class="text-base font-normal bg-gray-100 rounded px-2">№ {{ commercialStore.build_item.id
                                }}</p>
                            <p class="text-base font-normal text-brand-blue hidden">
                                ОБНОВЛЕНО {{ format_date(commercialStore.build_item.updated_at) }}
                            </p>
                        </div>

                    </div>

                </div>

                <div class="flex flex-col-reverse md:flex-col w-2/2 md:w-2/5">

                    <div class="items-center justify-between pt-5 flex md:hidden">
                        <span class="text-[13px] font-normal bg-gray-100 rounded px-2">№ {{
                            commercialStore.build_item.id
                            }}</span>
                        <p class="text-[13px] font-medium text-brand-blue hidden">
                            ОБНОВЛЕНО {{ format_date(commercialStore.build_item.updated_at) }} 
                        </p>
                    </div>

                    <div class="relative h-[500px] md:h-[600px] pt-3 md:pt-0 rounded-lg">

                        <OfferMap v-if="selectViewContainer == 'map'"
                            class="w-full h-full absolute rounded-lg overflow-hidden"
                            v-model="commercialStore.build_item" :header="commercialStore.build_item.name"
                            theme="light" />

                        <OfferPanorama v-if="selectViewContainer == 'panorama'"
                            class="w-full h-full absolute rounded-lg overflow-hidden bg-gray-200"
                            v-model="commercialStore.build_item" />

                        <div class="absolute md:bottom-0 w-full bottom-0 z-10">
                            <button v-if="selectViewContainer == 'map'" @click="selectViewContainer = 'panorama'"
                                class="flex items-center justify-center mb-6 bg-brand-blue text-white py-2 px-3 rounded gap-2 w-fit mx-auto font-medium">
                                <img src="/img/icons/ponarama.svg" alt="" />
                                Панорама
                            </button>
                            <button v-if="selectViewContainer == 'panorama'" @click="selectViewContainer = 'map'"
                                class="flex items-center justify-center mb-6 bg-brand-blue text-white py-2 px-3 rounded gap-2 w-fit mx-auto font-medium">
                                <img src="/img/icons/ponarama.svg" alt="" />
                                Карта
                            </button>
                            <div class="w-full md:h-24 h-[71px] flex items-center gap-6 bg-gray-700 pl-6 rounded-b-lg">
                                <img src="/img/icons/location.svg" class="w-[24px] md:w-[33px]" alt="" />
                                <div>
                                    <h1 v-if="commercialStore.build_item?.region"
                                        class="text-base md:text-xl text-[#E73235] font-bold">
                                        {{ commercialStore.build_item?.region }}
                                    </h1>
                                    <p class="text-base md:text-lg font-normal text-gray-50">
                                        {{ commercialStore.build_item?.ulica + ', ' || '' }}
                                        {{ commercialStore.build_item?.dom || '' }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col md:gap-5 gap-3.5 md:pt-4">

                        <div class="px-6 py-4 bg-white border rounded-lg">

                            <h3 v-if="commercialStore.build_item?.offertype && commercialStore.build_item?.offertype == 'arenda'"
                                class="text-brand-blue font-bold text-base md:text-lg">
                                КОНТАКТЫ
                            </h3>

                            <OfferPhoneView />

                            <div class="flex items-center gap-8 pt-2">
                                <div class="flex items-center gap-2 w-1/3">
                                    <img src="/public/img/icons/email.svg" alt="" />
                                    <p class="font-medium">ЭЛ.ПОЧТА</p>
                                </div>
                                <div class="flex w-2/3 justify-end">
                                    <p class="text-brand-grey truncate" :class="email ? 'w-auto' : 'w-20'">
                                        <a href="mailto:info@arendabc.ru" class="text-base">info@arendabc.ru</a>
                                    </p>
                                    <p class="text-brand-blue underline cursor-pointer text-base" v-if="!email"
                                        @click="email = true">
                                        Показать
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div class="px-6 py-4 bg-white border rounded-lg">
                            <h3 class="font-bold text-base md:text-lg uppercase text-brand-blue">
                                Заявка на объект
                            </h3>
                            <p class="text-brand-grey text-sm">
                                Наши специалисты проведут безопасную сделку
                            </p>


                            <form @submit.prevent="submitFormApplicationForObject" class="max-w-sm my-6">
                                <div class="mb-5">
                                    <label for="nameApplicationForObject"
                                        class="block mb-2 text-sm font-medium text-brand-grey dark:text-white">ФИО</label>
                                    <input type="name" id="nameApplicationForObject" v-model="formData.name"
                                        class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                                        placeholder="ФИО" required />
                                </div>
                                <div class="mb-5">
                                    <label for="emailApplicationForObject"
                                        class="block mb-2 text-sm font-medium text-brand-grey dark:text-white">Email</label>
                                    <input type="email" id="emailApplicationForObject" v-model="formData.email"
                                        class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                                        placeholder="Введите email" required />
                                </div>
                                <div class="mb-5">
                                    <label for="phoneApplicationForObject"
                                        class="block mb-2 text-sm font-medium text-brand-grey dark:text-white">Телефон</label>
                                    <input type="tel" id="phoneApplicationForObject" v-model="formData.phone"
                                        class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                                        placeholder="Введите телефон" required />
                                </div>
                                <button type="submit"
                                    class="text-white bg-brand-primary hover:bg-brand-primary-hover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Отправить</button>
                            </form>


                        </div>

                        <div class="hidden md:pt-3.5  md:pb-[30px] md:px-5 p-3.5 bg-white border rounded-lg">
                            <h3 class="font-bold text-base md:text-lg">ДОПОЛНИТЕЛЬНО</h3>

                            <div class="flex items-center gap-8 pt-3">
                                <div class="flex items-center gap-2 w-1/2">
                                    <img src="/public/img/icons/work.svg" alt="" />

                                    <p class="font-medium">УСН</p>
                                </div>
                                <p class="text-brand-grey">Есть</p>
                            </div>

                            <div class="flex items-center gap-8">
                                <div class="flex items-center gap-2 w-2/2 md:w-1/2">
                                    <img src="/public/img/icons/time.svg" alt="" />

                                    <p class="font-medium">РЕЖИМ РАБОТЫ</p>
                                </div>
                                <p class="text-brand-grey">9:00-21:00</p>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </section>

        <section class="hidden md:block" v-if="isVisible">
            <div class="container">

                <div
                    class="bg-white mt-3 p-2 md:pb-6 md:pt-6 md:bg-transparent md:border-0 border border-custom-gray rounded-lg bg-(url('/img/aboutbg.png'))">
                    <div class="flex items-center justify-between pb-6">
                        <h3 class="text-brand-grey font-extrabold uppercase text-xl">
                            Найдено
                            <span>
                                {{ commercialStore.build_offers.items.length }}
                                {{ godgodalet(commercialStore.build_offers.items.length, ['объект', 'объекта',
                                    'объектов']) }}
                                В
                                {{ commercialStore.build_item.name }}
                            </span>
                        </h3>
                    </div>

                    <div class="grid grid-cols-4 items-center gap-3">
                        <LayoutsCardBc v-for="item in commercialStore.build_offers.items" :key="item.id" :item="item" />
                    </div>
                </div>

            </div>
        </section>

    </div>
</template>


<style scoped lang="scss">
.swiper {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}

.swiper-slide {
    background-size: cover;
    background-position: center;
}

.mySwiper2 {
    height: 100%;
    width: 100%;

    .swiper-button-prev::after {
        content: "" !important;
    }
}

.mythumb {
    box-sizing: border-box;
    padding: 10px 0;
    display: flex;
    flex-direction: column;

    * {
        .swiper-wrapper {
            display: flex;
            flex-direction: column;
        }
    }
}

.mythumb .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
}

.mythumb .swiper-slide-thumb-active {
    opacity: 1;
}

.swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
